import axiosInstance from "../axiosInstance";

export const getNotifications=async(params={})=>
 (await axiosInstance.get("notifications/",{params})).data;

export const markNotificationRead=async(id,action="READ")=>
 (await axiosInstance.post(`notifications/${id}/read/`,{action})).data;

export const markAllNotificationsRead=async()=>
 (await axiosInstance.post("notifications/read-all/",{action:"READ"})).data;

export const deleteNotification=async id=>
 (await axiosInstance.delete(`notifications/${id}/`)).data;

export const getCampaigns=async()=>
 (await axiosInstance.get("communications/campaigns/")).data;

export const sendCampaign=async data=>
 (await axiosInstance.post("communications/campaigns/",data)).data;

export const searchRecipients=async search=>
 (await axiosInstance.get("communications/recipients/",{params:{search}})).data;
